import {Box, List, ListItem, ListItemAvatar, ListItemText, ListItemTextProps, Stack} from "@mui/material";
import EmployeeAvatar from "../employee-avatar/EmployeeAvatar";
import React from "react";
import {GuessTeam} from "./GuessNeighbourhoods";
import EmployeeLink from "../employee-link/EmployeeLink";
import {TeamPathPane} from "./TeamPathPane";

const tooltipListItemTextSlotProps: ListItemTextProps['slotProps'] = {secondary: {sx: {color: 'grey.400'}}}

export function TeamGuessTooltip({globalTeamSize, localTeamSize, team}: {
    team: GuessTeam,
    globalTeamSize: number,
    localTeamSize: number,
}) {
    return (
        <Stack spacing={2}>
            <List>
                <ListItem>
                    <ListItemText
                        primary={<TeamPathPane teamPath={team.commonManager.teamPath}/>}
                    />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                        <EmployeeAvatar employee={team.commonManager} sx={{border: "4px solid goldenrod"}}/>
                    </ListItemAvatar>
                    <ListItemText
                        primary={<EmployeeLink employee={team.commonManager} color="white"/>}
                        secondary="Manager"
                        slotProps={tooltipListItemTextSlotProps}
                    />
                </ListItem>
                {team.teammates.map(teammate => (
                    <ListItem key={teammate.id}>
                        <ListItemAvatar>
                            <EmployeeAvatar employee={teammate}/>
                        </ListItemAvatar>
                        <ListItemText>
                            <EmployeeLink employee={teammate} color="white"/>
                        </ListItemText>
                    </ListItem>
                ))}
                <ListItem>
                    <ListItemText
                        secondary={
                            <Box>
                                <b>{localTeamSize}</b> pax in Office | <b>{globalTeamSize}</b> pax in JetBrains
                            </Box>
                        }
                        slotProps={tooltipListItemTextSlotProps}
                    />
                </ListItem>
            </List>
        </Stack>
    );
}